module.exports = __webpack_public_path__ + "static/media/pickup_banner.e02f1819.jpg";